import React from "react";
import { Link, withRouter } from "react-router-dom";

import "./components.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

function Navigation(props) {
  const tokenString = sessionStorage.getItem("token");
  const userToken = JSON.parse(tokenString);
  const Username = userToken.username;
  //const UserID = userToken.userId;

  const logout = () => {
    sessionStorage.removeItem("token");
    window.location.reload(true);
  };

  return (
    <div className="navigation">
      <nav className="navbar navbar-expand navbar-dark grid-bg-colour">
        <div className="container">
          <Link className="navbar-brand" to="/">
            {Username} - WMS Portal
          </Link>

          <div>
            <ul className="navbar-nav ml-auto">
              {/* Stock Dropdown */}

              <li
                className={`nav-item dropdown ${
                  props.location.pathname === "/" ||
                  props.location.pathname === "/stock" ||
                  props.location.pathname === "/movements" ||
                  props.location.pathname === "/count"
                    ? "active"
                    : ""
                }`}
              >
                <a
                  className="nav-link dropdown-toggle"
                  href="#"
                  id="stockDropdown"
                  role="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  data-bs-toggle="dropdown"
                >
                  Stock
                </a>

                <div className="dropdown-menu" aria-labelledby="stockDropdown">
                  <Link
                    className={`dropdown-item ${
                      props.location.pathname === "/" ? "active" : ""
                    }`}
                    to="/"
                  >
                    Stock Home
                  </Link>

                  <Link
                    className={`dropdown-item ${
                      props.location.pathname === "/movements" ? "active" : ""
                    }`}
                    to="/movements"
                  >
                    Movements
                    <span className="sr-only">(current)</span>
                  </Link>

                  <Link
                    className={`dropdown-item ${
                      props.location.pathname === "/count" ? "active" : ""
                    }`}
                    to="/count"
                  >
                    Count
                  </Link>
                </div>
              </li>

              {/* Orders Dropdown */}

              <li
                className={`nav-item dropdown ${
                  props.location.pathname === "/shiplists" ||
                  props.location.pathname === "/enquiry" ||
                  props.location.pathname === "/picking"
                    ? "active"
                    : ""
                }`}
              >
                <a
                  className="nav-link dropdown-toggle"
                  href="#"
                  id="ordersDropdown"
                  role="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  data-bs-toggle="dropdown"
                >
                  Orders
                </a>

                <div className="dropdown-menu" aria-labelledby="ordersDropdown">
                  <Link
                    className={`dropdown-item ${
                      props.location.pathname === "/shiplists" ? "active" : ""
                    }`}
                    to="/shiplists"
                  >
                    Shiplists
                  </Link>

                  <Link
                    className={`dropdown-item ${
                      props.location.pathname === "/enquiry" ? "active" : ""
                    }`}
                    to="/enquiry"
                  >
                    Enquiry
                  </Link>

                  {/* <Link
                    className={`dropdown-item ${
                      props.location.pathname === "/picking" ? "active" : ""
                    }`}
                    to="/picking"
                  >
                    Picking
                  </Link>

                  <Link
                    className={`dropdown-item ${
                      props.location.pathname === "/receipt" ? "active" : ""
                    }`}
                    to="/receipt"
                  >
                    Receipt
                  </Link> */}
                </div>
              </li>
              {/* <li
                className={`nav-item  ${
                  props.location.pathname === `${"/" || "/stock"}`
                    ? "active"
                    : ""
                }`}
              >
                <Link className="nav-link" to="/">
                  Stock
                  <span className="sr-only">(current)</span>
                </Link>
              </li>

              <li
                className={`nav-item  ${
                  props.location.pathname === "/movements" ? "active" : ""
                }`}
              >
                <Link className="nav-link" to="/movements">
                  Movements
                  <span className="sr-only">(current)</span>
                </Link>
              </li>

              <li
                className={`nav-item  ${
                  props.location.pathname === "/count" ? "active" : ""
                }`}
              >
                <Link className="nav-link" to="/count">
                  Count
                  <span className="sr-only">(current)</span>
                </Link>
              </li>

              <li
                className={`nav-item  ${
                  props.location.pathname === "/shiplists" ? "active" : ""
                }`}
              >
                <Link className="nav-link" to="/shiplists">
                  Shiplists
                  <span className="sr-only">(current)</span>
                </Link>
              </li> */}

              <li>
                <div className="spacer"></div>
              </li>
              <li
                className={`nav-item  ${
                  props.location.pathname === "/Login" ? "active" : ""
                }`}
              >
                <Link className="nav-link" to="/" onClick={logout}>
                  Sign Out
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </div>
  );
}

export default withRouter(Navigation);
